<template>
  <div class="p-careers">

    <div class="s-header">
      <div class="s-header-copy">
        <div class="s-header-title">
          <ul class="f-xs">
            <li>Careers</li>
            <li>
              <a class="l-rg p-cta" target="_blank" follow="nofollow" href="https://statestreet-icx.efrontcloud.com/StateStreet">Investor Login</a>
            </li>
          </ul>
        </div>
        <div class="s-header-head">
          <h1 class="f-xl">
            <span class="f-xl-line">Driven.</span>
            <span class="f-xl-line">Collaborative.</span>
            <span class="f-xl-line">Inquisitive.</span>
          </h1>
        </div>
      </div>

      <div style="display: none;">
        <div class="s-header-scroll">
          <i class="s-header-indicator"></i>
          <p class="f-xs">Scroll &amp; Discover</p>
        </div>
      </div>

      <div class="s-header-image">
        <div class="s-header-src"></div>
      </div>

      <div class="scroll-down">
        <div class="scroll-down-arrow" @click="emitEventScroll"></div>
      </div>
    </div>

    <div class="s-marquee">
      <div class="s-marquee-head">
        <!-- <h3 class="f-xs">The Next Step</h3> -->
      </div>
      <div class="s-marquee-wrap">
        <h2 class="f-xl">We Seek Excellence</h2>
      </div>
    </div>

    <div class="s-text">
      <div class="s-text-head">
        <!-- <h3 class="f-xs">The Requirements</h3> -->
      </div>
      <div class="s-text-wrap">
        <p class="f-md" data-animate="fade">
        VR Capital employs a highly-select group of professionals. Emphasis is placed on candidates with outstanding academic and professional qualifications, innate inquisitiveness coupled with strong problem-solving capabilities, an ability to thrive in a fast-paced environment and a natural inclination towards teamwork and camaraderie.
        </p>

        <p class="f-md" data-animate="fade">
        Our teams include investments, finance & accounting, operations, legal & compliance, business development and IT. If you aim to work with the highest caliber people and strive towards achievement and success, we invite you to contact us and send your CV.
        </p>
      </div>
    </div>

    <Form />

    <!-- <div class="s-text">
      <div class="s-text-head">
        <h3 class="f-xs">Please get in touch</h3>
        <h2 class="f-xl" data-animate="stagger">VR Cares</h2>
      </div>
      <div class="s-text-wrap">
        <p class="f-md" data-animate="fade">
          To request additional information regarding VR, please provide the information requested below and submit.
        </p>
      </div>
      <div class="s-text-footer">
        <router-link class="b-rg p-cta" to="/contact">
          Contact
          <svg class="i-arrow" enable-background="new 0 0 39.6 24.4" viewBox="0 0 39.6 24.4" xmlns="http://www.w3.org/2000/svg">
            <polygon points="39.6 12.2 39.6 12.2 39.5 12.2 39.6 12.2 39.6 12.2 27.8 0 27.1 0.7 37.7 11.7 0 11.7 0 12.7 37.7 12.7 27.1 23.7 27.8 24.4 39.6 12.2 39.6 12.2 39.6 12.2"/>
          </svg>
        </router-link>
      </div>
    </div> -->

    <Footer />

  </div>
</template>

<script>
import { gsap } from 'gsap';
import Sniffer from 'sniffer';
import Footer from '@/components/footer/footer.vue';
import Form from '@/components/form/join.vue';

export default {
  components: {
    Form,
    Footer,
  },

  methods: {
    emitEventScroll() {
      const scrollToEvent = new CustomEvent('customScrollTo', {
        detail: { scrollVal: window.innerHeight },
      });
      if (Sniffer.isPhone) gsap.to('.a-scroll', { duration: 1, scrollTo: window.innerHeight });

      window.dispatchEvent(scrollToEvent);
    },
  },
};
</script>
